import { render, staticRenderFns } from "./DefiBorrowFUSDConfirmation.vue?vue&type=template&id=15f38846&"
import script from "./DefiBorrowFUSDConfirmation.vue?vue&type=script&lang=js&"
export * from "./DefiBorrowFUSDConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports